import { map } from "rxjs";
import { Injectable } from "@angular/core";

import { Hall, HallPayload } from "../../interfaces";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class HallsService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "halls/";
  }

  add(body: HallPayload) {
    return this.post<boolean>({ APIName: "add", body, showAlert: true });
  }

  update(body: HallPayload) {
    return this.put<boolean>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string | number) {
    return this.get<Hall>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<Partial<Hall>>) {
    return this.getPagedRequest<Hall[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<any[]>({ APIName: "getall" });
  }

  getBookableHalls() {
    return this.getPaged({
      pageNumber: 1,
      pageSize: 1000,
      filter: { isBookable: true },
      orderByValue: [
        {
          colId: "CreatedDate",
          sort: "desc",
        },
      ],
    }).pipe(map((res) => (res.data.length ? res.data : [])));
  }
}
